export default __webpack_public_path__ + "static/media/warningIcon.3f85b747.svg";